/**
 * public/js/core/sovereign-bus.js
 * -------------------------------------------------------------
 * 浩基主權總線 (SovereignBus) v1.0.0
 * 物理功能：提供全局事件分發，解耦地圖基座與功能組裝櫃 (Cabinets)。
 * -------------------------------------------------------------
 */

export class SovereignBus {
    constructor() {
        this.listeners = {};
        console.log("📡 [SovereignBus] Neural link active. Standardized protocol v1.0 initialized.");
    }

    /**
     * 註冊事件監聽
     * @param {string} eventName 參閱 docs/sovereign_registry/BUS_PROTOCOL.md
     */
    on(eventName, callback) {
        if (!this.listeners[eventName]) this.listeners[eventName] = [];
        this.listeners[eventName].push(callback);
        return () => this.off(eventName, callback);
    }

    /**
     * 發送事件
     */
    emit(eventName, payload) {
        console.log(`[Bus -> ${eventName}]`, payload);
        if (!this.listeners[eventName]) return;
        this.listeners[eventName].forEach(cb => cb(payload));
    }

    off(eventName, callback) {
        if (!this.listeners[eventName]) return;
        this.listeners[eventName] = this.listeners[eventName].filter(cb => cb !== callback);
    }
}

// 導出單例
export const bus = new SovereignBus();
window.SovereignBus = bus; // 備援給舊版非 ESM 腳本
